import type React from 'react';

import { Checkbox } from '@vlabs/uikit/components/controls/checkbox/Checkbox';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from '../ImageCheckForm.module.sass';

function BankCheckForm(): React.JSX.Element {
  const { register } = useFormContext();
  const { t } = useTranslation();
  return (
    <div className={st.Checks}>
      <div className={st.ChecksTitle}>
        {t('checks:image checks.form.select checks')}
      </div>
      <div className={st.ChecksContent}>

        <div className={st.ChecksItem}>
          <Checkbox
            {...register('liveness')}
            id="liveness"
            label={t('checks:estimations.liveness.titleWithImageModification') as unknown as string}
          />
          <div className={st.CheckItemDetailsDivider} />
          {t('checks:estimations.liveness.subtitleWithImageModification')}
        </div>

        <div className={st.ChecksItem}>
          <Checkbox
            {...register('deepfake')}
            id="deepfake"
            label={t('checks:estimations.deepfake.titleWithImageModification') as unknown as string}
          />
          <div className={st.CheckItemDetailsDivider} />
          {t('checks:estimations.deepfake.subtitleWithImageModification')}
        </div>

        <div className={st.ChecksItem}>
          <Checkbox
            {...register('iso')}
            id="iso"
            label={t('checks:estimations.iso.title') as unknown as string}
          />
        </div>

        <div className={st.ChecksItem}>
          <Checkbox
            {...register('icao')}
            id="icao"
            label={t('checks:estimations.icao.title') as unknown as string}
          />
        </div>

        <div className={st.ChecksItem}>
          <Checkbox
            {...register('mindigital')}
            id="mindigital"
            label={t('checks:estimations.mindigital.title') as unknown as string}
          />
        </div>

      </div>
    </div>
  );
}

export { BankCheckForm };
